const sign_in_experiences = {
    empty_content_url_of_terms_of_use: '你啟用了“使用條款”，請添加使用條款網址。',
    empty_social_connectors: '你啟用了社交登錄的方式。請至少選擇一個社交連接器。',
    enabled_connector_not_found: '未找到已啟用的 {{type}} 連接器',
    not_one_and_only_one_primary_sign_in_method: '主要的登錄方式必須有且僅有一個，請檢查你的輸入。',
    username_requires_password: '必須為用戶名註冊識別符啟用設置密碼。',
    passwordless_requires_verify: '必須為電子郵件/電話註冊識別符啟用驗證。',
    miss_sign_up_identifier_in_sign_in: '登錄方法必須包含註冊識別符。',
    password_sign_in_must_be_enabled: '必須在註冊中要求設置密碼時啟用密碼登錄。',
    code_sign_in_must_be_enabled: '必須在註冊中不要求設置密碼時啟用驗證碼登錄。',
    unsupported_default_language: '{{language}} 無法選擇為默認語言。',
    at_least_one_authentication_factor: '至少要選擇一個登錄要素',
    backup_code_cannot_be_enabled_alone: '備份碼不能單獨啟用。',
    duplicated_mfa_factors: '重複的多因素驗證要素。',
    email_verification_code_cannot_be_used_for_mfa: '當啟用電子郵件驗證用於登錄時，電子郵件驗證碼不能用於多因素驗證。',
    phone_verification_code_cannot_be_used_for_mfa: '當啟用SMS驗證用於登錄時，SMS驗證碼不能用於多因素驗證。',
    email_verification_code_cannot_be_used_for_sign_in: '當電子郵件驗證碼啟用用於多因素驗證時，不能用於登錄。',
    phone_verification_code_cannot_be_used_for_sign_in: '當SMS驗證碼啟用用於多因素驗證時，不能用於登錄。',
    adaptive_mfa_requires_mfa: '啟用自適應多因素驗證前必須先啟用多因素驗證。',
    adaptive_mfa_requires_non_skippable_policy: '自適應多因素驗證需要一個不可跳過的多因素驗證提示政策。使用PromptOnlyAtSignInMandatory或PromptAtSignInAndSignUpMandatory。',
    non_adaptive_mfa_requires_skippable_policy: '當自適應多因素驗證被禁用時，多因素驗證提示政策必須是可跳過的。不要使用PromptOnlyAtSignInMandatory或PromptAtSignInAndSignUpMandatory。',
    duplicated_sign_up_identifiers: '檢測到重複的註冊識別符。',
    missing_sign_up_identifiers: '主要註冊識別符不能為空。',
    invalid_custom_email_blocklist_format: '無效的自訂電子郵件封鎖清單項目：{{items, list(type:conjunction)}}。每個項目必須是有效的電子郵件地址或電子郵件域，例如：foo@example.com或 @example.com。',
    forgot_password_method_requires_connector: '忘記密碼方法需要配置對應的 {{method}} 連接器。',
    password_expiration_requires_forgot_password: '密碼過期需要至少配置一種帶有有效連接器的忘記密碼方式。',
    password_expiration_not_enabled: '密碼過期策略未啟用。在過期密碼前，請在登錄體驗設置中啟用它。',
    password_expiration_invalid_period_days: '啟用密碼到期策略時，有效期天數必須為正整數。',
    username_policy_case_conflicts_exist: '在存在僅大小寫不同的用戶名時，無法切換到大小寫不敏感的用戶名。請解決衝突後重試。',
};
export default Object.freeze(sign_in_experiences);
